import * as React from 'react';
import styled from 'styled-components';
import { DropdownContainer, CardColumn } from '../../dropdowns/card_dropdown_parts';
import { trackEvent } from '../../../../utils';
import StoreCard from './store_card';
import { space } from '@core-ds/primitives';

declare const Request: any;
declare const App;

const StyledDropdownContainer = styled(DropdownContainer)<{ mobile: boolean }>`
   padding-top: ${({ mobile }) => (mobile ? space[3] : space[2])};
   padding-bottom: ${space[3]};
`;

const updateStorePreference = (storePreference, currentStore) => {
   new Request.API_2_0('store/user/store_preference', {
      method: 'POST',
      onSuccess: () => {
         trackEvent(
            'Preferred Store',
            `${currentStore.storeCode} - ${storePreference.storeCode}`,
            window.location.href
         );
         if (App.storeRedirectLinks && App.storeRedirectLinks[storePreference.storeCode]) {
            window.location = App.storeRedirectLinks[storePreference.storeCode];
         } else if (App.onStorePage && App.storeUrls) {
            window.location = App.storeUrls[storePreference.storeCode];
         } else {
            window.location.reload();
         }
      },
      statusPanelMessage: _js('Submitting'),
   }).send({
      newStore: storePreference.storeCode,
   });
};

const StoreDropdown = ({ stores, mobile = undefined, currentStore }) => {
   return (
      <StyledDropdownContainer id="storeDropdown" mobile={mobile}>
         <CardColumn>
            {stores.map(store => (
               <StoreCard
                  key={store.name}
                  store={store}
                  mobile={mobile}
                  isDisplayStore={store.isDisplayStore}
                  updateStorePreference={() => {
                     updateStorePreference(store, currentStore);
                  }}
               />
            ))}
         </CardColumn>
      </StyledDropdownContainer>
   );
};

export default StoreDropdown;
